import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "inner-container" }
const _hoisted_2 = { class: "page-tag" }
const _hoisted_3 = {
  key: 0,
  class: "tag-detail"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'InnerContainer',
  props: {
  title:{
    type: String,
  },
  subTitle:{
    type: String,
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.subTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tag-detail_prefix" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(__props.subTitle), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})